import { MessageCircle } from "lucide-react";
import { waLink } from "../data/site";

export const FloatingWhatsApp = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Falar no WhatsApp"
    className="fixed bottom-6 right-6 z-50 grid place-items-center w-15 h-15 p-4 rounded-full bg-[#00E676] text-[#04120E] animate-pulse-glow transition-transform duration-300 hover:scale-110"
  >
    <MessageCircle size={26} />
  </a>
);
